

export const ExportTypes = [
    { key: 'Sticky', label: 'Stickies' },
    { key: 'IndexCard', label: 'Index Card' },
    { key: 'Token', label: 'Token' },
    { key: 'TaskCard', label: 'Task Card' },
    { key: 'RoadmapCard', label: 'Roadmap Card' },
    { key: 'JiraCard', label: 'Jira Card' },
];
